import fetch from '@/fetch'
import { Debounce } from '@/utils'
import { i18n } from '@/i18n'

const check = Debounce((data, passes, msg, scope) => {
  fetch(`/api/${scope}/validate/${data}`)
    .then(() => passes())
    .catch(() => passes(false, msg))
}, 300)

export default Validator => {
  Validator.registerAsync('emailAvailable', function (data, attribute, req, passes) {
    let [type, email = data, organizationNumber] = attribute.split(':')
    if (!new Validator({ email }, { email: 'email' }).passes()) return passes()

    check(
      [email, organizationNumber].filter(Boolean).join(':'),
      passes,
      i18n.t('emailHasAlreadyBeenAdded', { x: email }),
      type,
    )
  })
}
